/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc
 */
import * as References from './CampaignsAssociationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getAssociatedCrmIds
 */
export const GET_ASSOCIATED_CRM_IDS_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getAssociatedCrmIds';
export const GET_ASSOCIATED_CRM_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ASSOCIATED_CRM_IDS_QUERY_FIELD_NAME,
  args: ['campaignGuids', 'objectTypeIds'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAssociatedCrmIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#bulkAssociateFromCrmSearch
 */
export const BULK_ASSOCIATE_FROM_CRM_SEARCH_MUTATION_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_bulkAssociateFromCrmSearch';
export const BULK_ASSOCIATE_FROM_CRM_SEARCH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: BULK_ASSOCIATE_FROM_CRM_SEARCH_MUTATION_FIELD_NAME,
  args: ['campaignGuids', 'objectTypeId', 'filterGroups', 'query'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.bulkAssociateFromCrmSearchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#setAssociations
 */
export const SET_ASSOCIATIONS_MUTATION_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_setAssociations';
export const SET_ASSOCIATIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_ASSOCIATIONS_MUTATION_FIELD_NAME,
  args: ['campaignGuids', 'primaryCampaignGuid', 'assetObjectTypeId', 'crmAssetIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.setAssociationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#associateWithCampaigns
 */
export const ASSOCIATE_WITH_CAMPAIGNS_MUTATION_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_associateWithCampaigns';
export const ASSOCIATE_WITH_CAMPAIGNS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ASSOCIATE_WITH_CAMPAIGNS_MUTATION_FIELD_NAME,
  args: ['campaignGuids', 'campaignCrmId', 'assetObjectTypeName', 'assetObjectType', 'crmAssetIds'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.associateWithCampaignsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#dissociateFromCampaigns
 */
export const DISSOCIATE_FROM_CAMPAIGNS_MUTATION_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_dissociateFromCampaigns';
export const DISSOCIATE_FROM_CAMPAIGNS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DISSOCIATE_FROM_CAMPAIGNS_MUTATION_FIELD_NAME,
  args: ['campaignGuids', 'campaignCrmId', 'assetObjectTypeName', 'assetObjectType', 'crmAssetIds'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.dissociateFromCampaignsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getAssociableObjectTypes
 */
export const GET_ASSOCIABLE_OBJECT_TYPES_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getAssociableObjectTypes';
export const GET_ASSOCIABLE_OBJECT_TYPES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ASSOCIABLE_OBJECT_TYPES_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getAssociableObjectTypesRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getPortalAssociableObjectTypes
 */
export const GET_PORTAL_ASSOCIABLE_OBJECT_TYPES_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getPortalAssociableObjectTypes';
export const GET_PORTAL_ASSOCIABLE_OBJECT_TYPES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_ASSOCIABLE_OBJECT_TYPES_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getPortalAssociableObjectTypesRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getAssetMappings
 */
export const GET_ASSET_MAPPINGS_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getAssetMappings';
export const GET_ASSET_MAPPINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ASSET_MAPPINGS_QUERY_FIELD_NAME,
  args: ['objectTypeName', 'limit', 'offset', 'startDateInt', 'endDateInt', 'requestOptions', 'campaignObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getAssetMappingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getMetricTotals
 */
export const GET_METRIC_TOTALS_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getMetricTotals';
export const GET_METRIC_TOTALS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_METRIC_TOTALS_QUERY_FIELD_NAME,
  args: ['objectTypeName', 'limit', 'offset', 'startDateInt', 'endDateInt', 'requestOptions', 'campaignObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getMetricTotalsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getSingleAssetMapping
 */
export const GET_SINGLE_ASSET_MAPPING_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getSingleAssetMapping';
export const GET_SINGLE_ASSET_MAPPING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SINGLE_ASSET_MAPPING_QUERY_FIELD_NAME,
  args: ['objectTypeName', 'assetObjectId', 'startDateInt', 'endDateInt', 'requestOptions', 'campaignObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getSingleAssetMappingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getBatchAssetMapping
 */
export const GET_BATCH_ASSET_MAPPING_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getBatchAssetMapping';
export const GET_BATCH_ASSET_MAPPING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BATCH_ASSET_MAPPING_QUERY_FIELD_NAME,
  args: ['assetMappingRequestKeys', 'startDateInt', 'endDateInt', 'requestOptions', 'campaignObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getBatchAssetMappingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc#getMetricTotalsWithFirstPage
 */
export const GET_METRIC_TOTALS_WITH_FIRST_PAGE_QUERY_FIELD_NAME = 'com_hubspot_campaigns_association_rpc_CampaignsAssociationRpc_getMetricTotalsWithFirstPage';
export const GET_METRIC_TOTALS_WITH_FIRST_PAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_METRIC_TOTALS_WITH_FIRST_PAGE_QUERY_FIELD_NAME,
  args: ['limit', 'requestOptionsByObjectType', 'startDateInt', 'endDateInt', 'campaignObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getMetricTotalsWithFirstPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});